import { render, staticRenderFns } from "./TextFieldForm.vue?vue&type=template&id=50a86126"
import script from "./TextFieldForm.vue?vue&type=script&lang=js"
export * from "./TextFieldForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports